<template>
  <div class="chatbot-other-qa">
      <AskQuestion v-if="message.userInput" :question="message.userInput"/>
      <GetAnswer v-if="message.answer" :answer="message.answer"/>
      <div class="clear-float"></div> 
      <template v-if="showService">
        <Top3QaRecommend title="感谢您的支持！您还可以继续咨询其他问题。" />
        <div class="clear-float"></div>
        <ChatbotService />
      </template>
  </div>
</template>

<script>
import GetAnswer from '@/components/GetAnswer'
import AskQuestion from '@/components/AskQuestion'
import ChatbotService from '@/components/Service'
import Top3QaRecommend from '@/components/Top3QaRecommend'
import { scrollToBottom } from '@/utils'

  export default {
  name: 'OtherQA',
  components:{
    AskQuestion,
    GetAnswer,
    ChatbotService,
    Top3QaRecommend,
  },
  data(){
    return {
      showService: !window.serviceDelay,
    }
  },
  created(){
    console.log(this.showService);
    if (!this.showService) {
      setTimeout(() => {
        window.serviceDelay = false;
        this.showService = true
        setTimeout(() => {
          scrollToBottom(document.querySelector('#el-main'))
        }, 100)
      }, 2000);
    }
  },
  props:{
    message:Object,
  }
}
</script>

<style>

</style>
